module.exports = __webpack_public_path__ + "media/Audio17_i.c5ae11bf.wav";